
<template>
  <v-sheet class="filter-card">
    <span class="filter-card-label">{{ label }}</span>
    <v-text-field
      v-model="input"
      variant="outlined"
      hide-details
      density="compact"
    ></v-text-field>
  </v-sheet>
</template>

<script>
export default {
  name: 'TextInputFilter',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Text Filter'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    input: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  }
};
</script>
